import React from 'react';
import { Space, Typography, theme } from 'antd';
import { usePageShellResolved } from './PageShellProvider';

const { Title, Text } = Typography;

const PageChrome: React.FC = () => {
  const { token } = theme.useToken();
  const { title, subtitle, actions, filters, hideChrome } = usePageShellResolved();

  if (hideChrome) {
    return null;
  }

  const hasHeaderRow = title !== null || actions !== undefined;
  const hasFilters = filters !== undefined;

  if (!hasHeaderRow && !hasFilters) {
    return null;
  }

  return (
    <header
      style={{
        paddingTop: 8,
        paddingBottom: hasFilters ? 8 : 20,
      }}
    >
      {hasHeaderRow && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 12,
          }}
        >
          <Space direction="vertical" size={2} style={{ minWidth: 0, flex: 1 }}>
            {title !== null && (
              <Title
                level={3}
                style={{
                  margin: 0,
                  fontWeight: 700,
                  fontSize: 24,
                  lineHeight: 1.2,
                  letterSpacing: '-0.03em',
                  color: token.colorText,
                }}
              >
                {title}
              </Title>
            )}
            {subtitle && (
              <Text
                style={{
                  fontSize: 13,
                  fontWeight: 400,
                  color: token.colorTextSecondary,
                  lineHeight: 1.4,
                }}
              >
                {subtitle}
              </Text>
            )}
          </Space>
          {actions !== undefined && (
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 8,
                flexShrink: 0,
                minHeight: 32,
              }}
            >
              {actions}
            </div>
          )}
        </div>
      )}

      {hasFilters && (
        <div style={{ marginTop: 12 }}>
          {filters}
        </div>
      )}
    </header>
  );
};

export default PageChrome;
